import Select from 'common/components/form/inputs/Select';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useActions } from 'utils/hooks';
import { selectMenusList, selectIsTreeInitialized } from '../store/selectors';
import { components } from 'react-select';

import * as beaconActions from 'common/components/beacon/store/actions';

const MenuListSelector = ({ filter, ...rest }) => {
  const [getBeaconMenus] = useActions([beaconActions.getBeaconMenus]);

  const menus = useSelector(selectMenusList);
  const isInitialized = useSelector(selectIsTreeInitialized);

  useEffect(() => {
    if (!isInitialized) getBeaconMenus();
  }, [isInitialized, getBeaconMenus]);

  return (
    <Select
      placeholder="Select menu"
      getOptionValue={option => option.id}
      getOptionLabel={option => option.title}
      options={menus}
      components={{ Option, SingleValue }}
      value={filter?.value}
      {...rest}
    />
  );
};

const Option = props => {
  return (
    <components.Option {...props}>
      <span className={`ps-${props.data.level}`}>{props.data.title}</span>
    </components.Option>
  );
};

const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>
    {props.data.breadcrumbs.map(({ title }) => title).join(' > ')}
  </components.SingleValue>
);

export default MenuListSelector;
